import { SWRConfiguration, SWRResponse } from 'swr';
import { GetRadiologistPatientsResponse, GetRadiologistPatients } from '../../api/dtos';
import { useMemo } from 'react';
import { useGet } from '@ngt/opms';

const getData = (response?: SWRResponse<GetRadiologistPatientsResponse, GetRadiologistPatientsResponse>) => response?.data?.patients;
const getError = (response?: SWRResponse<GetRadiologistPatientsResponse, GetRadiologistPatientsResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useRadiologistPatients = (username?: string, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        return username ?
            () => {
                return new GetRadiologistPatients({ radiologistUserName: username });
            } :
            undefined;
    }, [username])

    return useGet(request, { getData, getError}, configuration);
};

export default useRadiologistPatients;